import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';

interface IExpandButtonProps {
  $expanded: boolean;
  isAlternative?: boolean;
  $hidden?: boolean;
}

export const ExpandButton = styled.button<IExpandButtonProps>(
  props => css`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    min-height: 100%;
    transition: background-color ${layout.animations.buttonTransition};
    background-color: transparent;
    padding: ${layout.measurements.spacing050};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;

    ${media.mediumUp`
      padding-left: ${layout.measurements.spacing100};
    `};

    ${props.$expanded &&
      css`
        border-bottom-left-radius: 0;
      `}

    &:hover {
      background-color: ${props.theme.colors.base100};
    }

    &.focus-visible {
      outline: ${props.theme.text.linkExternalHover} dotted 1px;
      outline: -webkit-focus-ring-color auto 1px;
    }

    ${props.$hidden &&
      css`
        display: none;
      `}
  `
);
